import * as React from 'react'
import { SourceBox, TargetBox } from './boxes'
import CreateLocationButton from '../create_location_button'

const { I18n } = window as any

const splitLocationsOnTwoTypes = (locations) => {
  const sourceList = []
  const targetList = []

  if (locations && Array.isArray(locations)) {
    locations.forEach((location: { selected: any; visible: any; targetVisible: any }) => {
      if (location.selected) {
        if (location.targetVisible !== false) {
          targetList.push(location)
        }
      } else if (location.visible) {
        sourceList.push(location)
      }
    })
  }

  return { source: sourceList, target: targetList }
}

type LocationsContentProps = {
  locations: any
  actions: any
  tags: any
  regions: any
  targetFilter: string
  ByTagsSelector: any
  approvedLocationIDs: any
  campaignLocationsNeedApproval: any
  exportLocationApprovalsUrl: string
  companyId: number
  canCreateLocation: boolean
  countries: Array<{ label: string; value: string }>
  locationManagers: Array<{ label: string; value: number }>
}

export default function LocationsContent(props: LocationsContentProps) {
  const {
    actions,
    locations,
    tags,
    regions,
    targetFilter,
    ByTagsSelector,
    approvedLocationIDs,
    campaignLocationsNeedApproval,
    exportLocationApprovalsUrl,
    companyId,
    canCreateLocation,
    countries,
    locationManagers,
  } = props
  const splitLocations = splitLocationsOnTwoTypes(locations)

  const filterBy = (e) => {
    actions.filterBy(e.target.value)
  }

  const filterByTags = (filterRegions) => {
    actions.filterByTags(filterRegions)
  }

  const filterTargetBy = (e) => {
    actions.filterTargetBy(e.target.value)
  }

  return (
    <div className="row locations-selector-boxes-row">
      <div className="col-6">
        <div className="col-12 d-flex mb-2">
          <div className="flex-grow-1 mr-2">
            <input
              type="text"
              className="search form-control"
              id="search"
              placeholder={I18n.t('application.titles.filter')}
              onChange={filterBy}
            />
          </div>
          <div className="flex-grow-1 mr-2 tags-selector">
            <ByTagsSelector items={tags || []} selectTag={filterByTags} />
          </div>
          {canCreateLocation && (
            <div>
              <CreateLocationButton companyId={companyId} countries={countries} locationManagers={locationManagers} />
            </div>
          )}
        </div>
        <div className="col-12 locations-selector-scrollable-box-cont">
          <SourceBox
            items={splitLocations.source}
            selectItem={actions.selectItem}
            selectAll={actions.selectAll}
            showRegions={(regions || []).length > 0}
          />
        </div>
      </div>
      <div className="col-6">
        {campaignLocationsNeedApproval ? (
          <div className="d-flex mb-2">
            <div className="flex-grow-1 mr-3">
              <input
                type="text"
                className="search form-control"
                id="target-search"
                placeholder={I18n.t('application.titles.filter')}
                value={targetFilter}
                onChange={filterTargetBy}
              />
            </div>
            <div className="campaign-target-locations-actions">
              <a
                href={exportLocationApprovalsUrl}
                className="btn btn-outline-secondary"
                data-method="post"
                data-remote="true"
              >
                {I18n.t('campaigns.location_approvals.export_location_approvals')}
              </a>
            </div>
          </div>
        ) : (
          <div className="mb-2">
            <input
              type="text"
              className="search form-control"
              id="target-search"
              placeholder={I18n.t('application.titles.filter')}
              value={targetFilter}
              onChange={filterTargetBy}
            />
          </div>
        )}
        <div className="locations-selector-scrollable-box-cont">
          <TargetBox
            items={splitLocations.target}
            removeItem={actions.removeItem}
            removeAll={actions.removeAll}
            approvedLocationIDs={approvedLocationIDs}
            campaignLocationsNeedApproval={campaignLocationsNeedApproval}
          />
        </div>
      </div>
    </div>
  )
}
